import { useShallow } from 'zustand/react/shallow';
import { ParameterType } from '@/types/parameterTypes';
import { I18n } from '@/i18n/I18n';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CUSTOM_FIELD_TYPES } from '@/types/customFieldTypes';
import { Parameter } from '@/backend/models/parameter';
import { File } from '@/backend/models/file';
import { useParameterStore } from '@/frontend/store/ParameterStore';

export function CodeOutput(props: { operationId: string }) {
  const { operationId } = props;
  const parameters = useParameterStore(useShallow((state) => state.parametersForSubjectAndType(operationId, ParameterType.OUTPUT)));

  if (parameters.length === 0) {
    return null;
  }

  return (
    <div className='card'>
      <div className='card-header'>{I18n.get('codeOutputParameters')}</div>
      <div className="card-body">
        <table className='table table-sm table-bordered table-hover'>
          <thead>
            <tr className='table-light'>
              <th>{I18n.get('title')}</th>
              <th>{I18n.get('type')}</th>
              <th>{I18n.get('identifier')}</th>
              <th>{I18n.get('value')}</th>
            </tr>
          </thead>
          <tbody>
            { parameters.map((parameter) => {
              return (
                <tr className={parameter.hasEmptyField() ? 'table-warning' : ''} id={parameter.id} key={parameter.id}>
                  <td>{parameter.title}</td>
                  <td>{I18n.get(parameter.fieldType)}</td>
                  <td><code>{parameter.identifier}</code></td>
                  <td><code><OutputValue parameter={parameter} /></code></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function OutputValue(props: { parameter: Parameter }) {
  const { parameter } = props;
  // const downloadFileById = useGlobalStore((state) => state.downloadFileById);

  if (parameter.hasEmptyField()) {
    return <MissingOutputTooltip />;
  }

  if (parameter.fieldType === CUSTOM_FIELD_TYPES.File) {
    const files: File[] = [];
    parameter.fields.forEach((field) => {
      if (field.file) files.push(field.file);
    });

    return (
      <>
        { files.map((file) => (
          <button type='button' className='btn btn-link' onClick={() => {}} key={file.id} disabled>
            { file.fileName }
          </button>
        ))}
      </>
    );
  }

  return parameter.concatArray();
}

function MissingOutputTooltip() {
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="missing_output_tooltip">{I18n.get('missingOutput')}</Tooltip>}
      >
      <svg data-testid='exclamation-circle' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-exclamation-circle" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
        <path d="M7.002 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 4.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
      </svg>
    </OverlayTrigger>
  );
}
